module.exports = __webpack_public_path__ + "img/logo.35845457.png";